import { Component } from '@angular/core';
import { InputWidget } from '../input-widget';
import { DateHelper } from 'app/main/content/misc/date.module';

@Component({
  selector: 'app-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss'],
})
export class DatepickerComponent extends InputWidget {

  constructor(private dateHelper: DateHelper) {
    super();
  }

  getAdjustedValue(val: any): Date {
    const m = this.dateHelper.relativeToAbsolute(val);
    const v = m ? this.dateHelper.utcDate(m): null;
    return v;
  }

  setValue(val){
    const v = this.getAdjustedValue(val);
    const s = (this.dateHelper.isDateObject(val)) ? val.getSeconds() : 0;
    const m = this.dateHelper.addSeconds(v , s);
    super.setValue(m);
  }

  setMin(val){
    super.setMin(this.getAdjustedValue(val));
  }

  setMax(val){
    super.setMax(this.getAdjustedValue(val));
  }
}
